import React from 'react';
import { Button, Input, Tooltip, Upload } from 'antd';
import { ReloadOutlined, ExportOutlined, ImportOutlined, DeleteOutlined } from '@ant-design/icons';
import s from './Filters.module.scss';

const { Search } = Input;

export const Filters = ({
  handleSearch,
  buttonEventHandler,
  selectedKeys,
  onUpdate,
  handleExportXlsxFile,
  handleLoadRawXPath,
  exportProps,
}: {
  handleSearch: (e: string) => void;
  buttonEventHandler: (type: string) => void;
  selectedKeys: Array<number>;
  onUpdate: (key: string) => void;
  handleExportXlsxFile: () => void;
  handleLoadRawXPath: () => void;
  exportProps?: object;
}) => {
  const onSearch = (e) => {
    const value = e.target.value;
    handleSearch(value);
  };

  return (
    <div className={s.Filters}>
      <div className={s.leftZone}>
        <Search
          placeholder='Найти'
          onChange={onSearch}
          style={{ width: '264px', marginRight: '16px' }}
        />
      </div>

      <div className={s.rightZone}>
        {selectedKeys.length ? (
          <Button onClick={() => buttonEventHandler('multiple')} icon={<DeleteOutlined />}></Button>
        ) : (
          ''
        )}

        <Button onClick={() => onUpdate('')} icon={<ReloadOutlined />}>
          Обновить
        </Button>
        <Button onClick={handleExportXlsxFile} icon={<ExportOutlined />}>
          Экспорт
        </Button>
        <Upload {...exportProps}>
          <Button icon={<ImportOutlined />}>Импорт</Button>
        </Upload>

        <Tooltip
          placement='topLeft'
          title={'Будут подгруженны только данные, которые были сохранены на обработке CDA'}
        >
          <Button onClick={handleLoadRawXPath} type='primary'>
            Подгрузить необработанные xPath
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
